import React from 'react';

const SIZE_MAP = {
  inherit: '1em',
  small: 14,
  medium: 16,
  large: 20,
  xlarge: 28,
};

const resolveSize = (size) => {
  if (size == null) return SIZE_MAP.medium;
  if (typeof size === 'number') return size;
  return SIZE_MAP[size] ?? SIZE_MAP.medium;
};

const Icon = React.forwardRef(function Icon(
  { as: IconComponent, size = 'medium', strokeWidth = 2, color = 'currentColor', style, className, ...rest },
  ref,
) {
  if (!IconComponent) return null;
  const resolvedSize = resolveSize(size);
  return (
    <IconComponent
      ref={ref}
      size={resolvedSize}
      strokeWidth={strokeWidth}
      color={color}
      className={className}
      style={{
        display: 'inline-flex',
        verticalAlign: 'middle',
        flexShrink: 0,
        ...style,
      }}
      {...rest}
    />
  );
});

export default Icon;
